import { useMutation } from '@tanstack/react-query';
import { LoginSchema } from '../lib/schemas';
import axiosInstance from '../lib/axiosInstance';
import { Auth } from '../types/auth.model';

export const useLogin = () => {
  return useMutation({
    mutationFn: async (data: { username: string; password: string }) => {
      const { username, password } = LoginSchema.parse(data);
      const response = await axiosInstance.post<Auth>('/auth', {
        username,
        password,
      });
      return response.data;
    },
  });
};
